<template lang="html">
  <div class="print-tittle">
    <span ref="tittle">{{ VBindTittle }}</span>
    <img src="/static/logo.svg">
  </div>
</template>

<script>
/* Imports are written here */
export default {
  components: {},
  props: {
    tittle: "",
    tittleColor: ""
  },
  data() {
    return {
      VBindTittle: "",
      VBindTittleColor: "sad",
    };
  },
  computed: {},
  watch: {},
  methods: {},
  beforeMount() {
    this.VBindTittle = this.tittle;
  },
  mounted() {
    if (this.tittleColor) {
      this.$refs.tittle.style.color = this.tittleColor;
    }
  }
};
</script>

<style lang="css" scoped>
.print-tittle {
  height: 60px;
}
img {
  display: block !important;
  float: right;
  width: 130px;
  position: relative;
  bottom: -16px;
  right: 12px;
}
span {
  color: #2873de;
  margin: 0em 1em 0em 1.1em;
  padding: 0;
  font-size: 21px;
  font-weight: 400;
  position: relative;
  top: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/PrintTittle.vue